import { useState, useEffect, useContext } from 'react';
import {AuthFetchAtu, AuthFetch, Fetch } from '../services/api';
import { notify } from '../utils/utils';
import { useModal } from './useModal';
import QrDefault from '../assets/images/QRDefault.jpg'
import { UserContext } from '../context/provider/UserProvider';


const urlBaseMinio = process.env.REACT_APP_BEEDRONE_WEB_API_MINIO;

export const useEnlaceQr = () => {
    
    const [ unidadQr, setUnidadQr ] = useState({})
    const [ unidadesQr, setUnidadesQr ] = useState([])
    const [ loading, setLoading ] = useState(false)
    const [ qrUrl, setQrUrl ] = useState(QrDefault);
    const [ isOpenModalUnidadQr, openModalUnidadQr, closeModalUnidadQr ] = useModal(false);
    const [ detalleYape, setDetalleYape ] = useState({ telefono: '', url: '', datosYape: ''})
    const { stateUser } = useContext(UserContext)
    
    const verQr = (nomCarpeta,nombreFoto) => {
        setQrUrl(`${urlBaseMinio}/Archivo/verImagen?NombreCarpeta=${nomCarpeta}&NombreImagen=${nombreFoto}`);
    }
    
    const generarQr = async(unidad,qrTipo)=> {
        console.log("entro al generar QR unidad y qrTipo -> ", unidad, qrTipo)
        setLoading(true)



        if(qrTipo == 1 ){ //BEEX PAGOS

            const response = await AuthFetch('/Qr/qrGenerate',{
                method : 'POST',
                body : JSON.stringify({
                    codigoEmpresa: unidad.codEmpresa,
                    codigoRuta:unidad.codRuta,
                    codigoUnidad: unidad.codUnidad,
                    codQrTipo: qrTipo //beex=1 - atu=2
                
                })
            })
            console.log("response Generar QR -> ", response)
            notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error')
            setLoading(false)

        } else{//QR ATU
            const response = await AuthFetchAtu('/Qr/generarQrAtu',{
                method : 'POST',
                body : JSON.stringify({
                        codEmpresa: unidad.codEmpresa,
                        codUnidad: unidad.codUnidad,
                        codQrTipo: 2,
                        codUsuarioOauthCreacion: 1,
                        nomPersonaOauthCreacion: "admin",
                        apePatPersonaOauthCreacion: "admin",
                        apeMatPersonaOauthCreacion: "admin"
                    })
            })
            console.log("response Generar QR -> ", response)
            notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error')
            setLoading(false)
        }
    }




    

    const activarInactivarQr= async(unidadSeleccionada)=> {
        setLoading(true)
        console.log("unidad seleccionada en activar/inactivar QR -> ", unidadSeleccionada)
        const response = await AuthFetch(`/Qr/updateQrStatus?${new URLSearchParams({
            codEmpresa: unidadSeleccionada.unidad.codEmpresa,
            codUnidad: unidadSeleccionada.unidad.codUnidad,
            accionQrBeex: unidadSeleccionada.qrTipo == 1 ? (unidadSeleccionada.unidad.activoQrBeex ? 0 : 1) : (unidadSeleccionada.unidad.activoQrATU ? 0 : 1),
            CodQrTipo: unidadSeleccionada.qrTipo,
          })}`,{
            method:"PUT",
          }
        )
        setLoading(false)
        notify(response.isValid? response.content: response.exceptions[0].description, response.isValid? 'success':'error')
    }

    const listarUnidadesQr = async (codEmpresa,codRuta) => {
        console.log("ENTRO AL LISTAR UNIDADES QR")
        if(!codEmpresa ) {
            notify("Debe seleccionar una empresa", "info")
            return;
        }


        if(!codRuta){
            notify("Debe seleccionar una ruta ", "info")
            return
        }


        // return
        // const response = await AuthFetchAtu('/Qr/obtenerListaUnidades?' + new URLSearchParams({
            const response = await AuthFetch('/Qr/unitsCompany?' + new URLSearchParams({
            codEmpresa: codEmpresa, 
            codRuta: codRuta,
        }))
        console.log("RESPONSE LISTAR UNIDADES QR -> ", response)

        if(response.isValid){
            setUnidadesQr(response.content)
        }else{
            notify(response.exceptions[0].description, "error")
            setUnidadesQr([])
        }
    }

    const obtenerUnidadQr = async (unidadQr,qrTipo) => {

        console.log("Entro al obtener Unidad -> ", unidadQr )

        const response = await AuthFetch('/Qr/unitCompany?' + new URLSearchParams({
            codEmpresa: unidadQr.codEmpresa,
            codUnidad: unidadQr.codUnidad
        }))

        console.log("Response obtener Unidad-> ", response)
        if (response.isValid === true){
            openModalUnidadQr()
            setUnidadQr(response.content)

        qrTipo==1? verQr(response.content.nomCarpetaQrBeex,response.content.nomFotoQrBeeX) : verQr(response.content.nomCarpetaQrATU,response.content.nomFotoQrATU)
        
        }else{
            notify(response.exceptions[0].description,'error')
            setUnidadQr({})
        }
    }

    const listarDetalleQrYape = async (codEmpresa, codQrYape, codUnidad) => {
        try{
            const response = await AuthFetch('/Qr/unitCompany?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                codUnidad: codUnidad
            }))
            setUnidadQr(response.isValid ? response.content : {})
            if(codQrYape !== 0){
                const response = await AuthFetch('/Qr/qrYapeDetail?' + new URLSearchParams({
                    CodEmpresa: codEmpresa,
                    CodQrYape: codQrYape,
                }));
                !response.isValid && notify(response.exceptions[0].description, 'error');
                setDetalleYape(response.isValid ? response.content[0] : [{ telefono: '', url: '', codEmpresa: codEmpresa, codUnidad: codUnidad }])
                return
            }
            setDetalleYape({ telefono: '', url: '', codEmpresa: codEmpresa, codUnidad: codUnidad });
        }
        catch(e)
        {
            notify('Ocurrió un error en el servicio', 'error');
            setDetalleYape({ telefono: '', url: '', codEmpresa: codEmpresa, codUnidad: codUnidad });
        }

    }

    const editarValorDetalleYape = (key, value) => {
        setDetalleYape(detalle => {
            return{
                ...detalle,
                [key]: value
            }
        })
    }

    const guardarQrYape = async (telefono, codUnidad, codEmpresa, urlImagenQrYape, imagenBase64) => {
        try
        {
            const response = await AuthFetch('/Qr/registerQrYape?' + new URLSearchParams({ CodEmpresa: codEmpresa }),
            { // ? + new URLSearchParams({ CodEmpresa: codEmpresa })
                method: 'POST',
                body: JSON.stringify({
                    UIDAccion: stateUser.uid ,
                    Telefono : telefono,
                    Url: urlImagenQrYape,
                    CodUnidad: codUnidad,
                    ImagenQrYape: imagenBase64
                }),
            })
            notify((response.isValid ? response.content : response.exceptions[0].description), (response.isValid ? 'success' : 'error'));
            return response.isValid
        }
        catch(e)
        {
            notify('Ocurrió un error en el servicio', 'error')
            console.log('Error al guardar imagen qr yape: ',e);

        }
    }

    return { 
        unidadQr,
        unidadesQr,
        qrUrl,
        loading,
        isOpenModalUnidadQr,
        closeModalUnidadQr,
        generarQr,
        activarInactivarQr,
        listarUnidadesQr,
        obtenerUnidadQr,
        listarDetalleQrYape,
        detalleYape,
        editarValorDetalleYape,
        guardarQrYape,
    }
}

